<article>
  <header>
    <strong>Gestão de Usuários</strong>
    <section>
      <app-primary-button
        *ngIf="hasSupervisorRole"
        label="Novo Usuário"
        icon="assets/icons/add.svg"
        [color]="ButtonColorEnum.common"
        (clickFunc)="navigateToNewForm()"
      ></app-primary-button>
    </section>
  </header>
  <main>
    <app-user-list-header></app-user-list-header>
    <ng-container *ngIf="isLoading">
      <div *ngFor="let i of [1, 2, 3, 4, 5]" class="skeleton">
        <div class="skeleton-column">
          <div class="skeleton-item"></div>
        </div>
      </div>
    </ng-container>
    <app-user-list-item
      *ngFor="let user of userList"
      [data]="user"
    ></app-user-list-item>
    <app-paginator
      [page]="page"
      [totalPages]="totalPages"
      [elementsShowing]="userList.length"
      [totalElements]="totalItems"
      (selectPageFunc)="handleSelectPage($event)"
    ></app-paginator>
  </main>
</article>
